import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { services } from '../../data/services';
import { SectionHeading } from '../ui/SectionHeading';
export function ServicesGrid() {
  const {
    t,
    b
  } = useLanguage();
  return <section id="services" className="scroll-mt-24 bg-white py-20 md:py-24" aria-labelledby="services-title" data-id="element-356" data-mp="38lo4n2wt5wxx">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8" data-id="element-357" data-mp="2b0s4zw5orie9">
        <SectionHeading id="services-title" title={t('services.title')} subtitle={t('services.sub')} data-id="element-358" data-mp="2fxiicbq3vzvz" />

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-359" data-mp="2kwbvg31hdovm">
          {services.map(service => {
          const Icon = service.icon;
          return <article key={service.slug} className="group relative flex flex-col border-l-4 border-transparent bg-mist p-6 transition-[transform,border-color,box-shadow] duration-200 ease-smooth hover:-translate-y-1 hover:border-brand-700 hover:shadow-lg" data-id="element-360" data-mp="7fpoxn7l4o8">
                <Icon className="h-9 w-9 text-brand-700" aria-hidden="true" data-id="element-361" data-mp="hn8h9cem1yt0" />
                <h3 className="mt-5 font-display text-lg font-bold leading-snug text-navy" data-id="element-362" data-mp="conep6bvz31e">{b(service.title)}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-muted" data-id="element-363" data-mp="8nbujgbs7a0l">{b(service.short)}</p>
                <ul className="mt-4 space-y-1.5 text-sm text-ink-muted" data-id="element-364" data-mp="3npaamxjctia">
                  {service.bullets.slice(0, 3).map(bullet => <li key={bullet.en} className="flex gap-2" data-id="element-365" data-mp="3v1v2au693qy3">
                      <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-cta" aria-hidden="true" data-id="element-366" data-mp="3q30k9ug3y6f1" />
                      {b(bullet)}
                    </li>)}
                </ul>
                <Link to={`/services/${service.slug}`} className="mt-auto inline-flex items-center gap-1.5 pt-6 text-sm font-bold text-brand-700 transition-colors duration-150 ease-smooth hover:text-brand-800" data-id="element-367" data-mp="3h3deyxk9cggp">
                  <span className="after:absolute after:inset-0 after:content-['']" data-id="element-368" data-mp="32ij5gog4wll9">{t('cta.learnMore')}</span>
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-369" data-mp="2shyzx9ll0ux8" />
                  <span className="sr-only" data-id="element-370" data-mp="3l6wgn8a5ajnv">— {b(service.title)}</span>
                </Link>
              </article>;
        })}
        </div>
      </div>
    </section>;
}